// extracted by mini-css-extract-plugin
module.exports = {"headerInfo":"ReservationDetail_headerInfo__3Oyf3","loadingContainer":"ReservationDetail_loadingContainer__2yYiP"};